import templateUrl from "emun.customer/cleanup/customer-cleanup.htm";
import basicController from "servicestack/basic.controller.properties";
import customerConfig from "emun.customer/customer.config";
import authConfig from "emun.auth/auth.config";
import AutoQuery from "servicestack/auto-query/auto-query";
import ServiceBus from 'servicestack/service-bus'
import modals from "webmodals/modals";
import ContactPopup from "emun.customer/customer-contact.popover";
import { camelCase } from "lodash";
import controller from "emun.customer/cleanup/customer-cleanup.controller";

	  
export default {
	bindings: {
		retailerId: "@"
	},
	controller,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};
